import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=024e129c&scoped=true"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=024e129c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e129c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024e129c')) {
      api.createRecord('024e129c', component.options)
    } else {
      api.reload('024e129c', component.options)
    }
    module.hot.accept("./Buscador.vue?vue&type=template&id=024e129c&scoped=true", function () {
      api.rerender('024e129c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/Buscador.vue"
export default component.exports